import { StyledFooter } from './style';

const Footer = () => {
  return <StyledFooter>
    <div className="container">PSPRO © 2023 京ICP备19019865号 400-800-8061</div>
  </StyledFooter>;
};

export default Footer;
